import React from 'react';
import { useRouter } from 'next/router';
import posthog from 'posthog-js';
import { CreatorCard } from '../../ui/molecules/CreatorCard';
import { useStore } from '../../store';
import { isUserLoggedIn } from '../../utils/analytics';

type CreatorCardContainerProps = {
  fullName: string;
  src?: string | null;
  href: string;
  collectionHandle?: string;
  sectionName?: string;
  className?: string;
};

const CreatorCardContainer: React.FC<CreatorCardContainerProps> = ({
  fullName,
  src,
  href,
  collectionHandle,
  sectionName,
  className,
}) => {
  const { state } = useStore();
  const { asPath } = useRouter();

  const handleClick = () => {
    posthog.capture('creator_card_click', {
      creator_name: fullName,
      collection_handle: collectionHandle,
      section_name: sectionName,
      location: asPath,
      is_logged_in: isUserLoggedIn(state.user),
    });
  };

  return (
    <a href={href} onClick={handleClick}>
      <CreatorCard fullName={fullName} src={src} className={className} />
    </a>
  );
};

export default CreatorCardContainer;
